import api from '../services/api';

export const DEFAULT_REFUND_POLICY = {
  reminderDay: 15,
  firstPenaltyDay: 30,
  firstPenaltyAmount: 50,
  secondPenaltyDay: 35,
  secondPenaltyAmount: 100,
  formCloseDay: 40,
};

let cachedPolicy = null;

export const normalizeRefundPolicy = (policy) => ({
  reminderDay: Number(policy?.reminderDay ?? DEFAULT_REFUND_POLICY.reminderDay),
  firstPenaltyDay: Number(policy?.firstPenaltyDay ?? DEFAULT_REFUND_POLICY.firstPenaltyDay),
  firstPenaltyAmount: Number(policy?.firstPenaltyAmount ?? DEFAULT_REFUND_POLICY.firstPenaltyAmount),
  secondPenaltyDay: Number(policy?.secondPenaltyDay ?? DEFAULT_REFUND_POLICY.secondPenaltyDay),
  secondPenaltyAmount: Number(policy?.secondPenaltyAmount ?? DEFAULT_REFUND_POLICY.secondPenaltyAmount),
  formCloseDay: Number(policy?.formCloseDay ?? DEFAULT_REFUND_POLICY.formCloseDay),
});

export const fetchRefundPolicy = async ({ force = false } = {}) => {
  if (cachedPolicy && !force) {
    return cachedPolicy;
  }

  try {
    const response = await api.get('/refund-policy/settings');
    const policy = response.data?.data || response.data;
    cachedPolicy = normalizeRefundPolicy(policy);
    return cachedPolicy;
  } catch (error) {
    console.error('Failed to load refund policy settings:', error);
    return normalizeRefundPolicy(DEFAULT_REFUND_POLICY);
  }
};

export const clearRefundPolicyCache = () => {
  cachedPolicy = null;
};

export const buildRefundPolicyLines = (policyInput) => {
  const policy = normalizeRefundPolicy(policyInput);
  return [
    '⏳ REFUND FORM RULES (counting from order form date):',
    `• Fill refund form within ${policy.formCloseDay} days`,
    `• Day ${policy.formCloseDay}+: Refund form CLOSED permanently`,
    `• Day ${policy.firstPenaltyDay}+: ₹${policy.firstPenaltyAmount} penalty`,
    `• Day ${policy.secondPenaltyDay}+: ₹${policy.secondPenaltyAmount} penalty`,
  ];
};

export const buildRefundPolicyBulletItems = (policyInput) => {
  const policy = normalizeRefundPolicy(policyInput);
  return [
    `Refund form must be filled within ${policy.formCloseDay} days of the order form date.`,
    `After day ${policy.formCloseDay}, the refund form is closed permanently — no refund can be submitted.`,
    `Day ${policy.firstPenaltyDay}+: ₹${policy.firstPenaltyAmount} penalty deducted from your payout if refund is late.`,
    `Day ${policy.secondPenaltyDay}+: ₹${policy.secondPenaltyAmount} penalty deducted from your payout if refund is late.`,
  ];
};
